import { render } from "./BannerCreateEdit.vue?vue&type=template&id=53a3b586&scoped=true"
import script from "./BannerCreateEdit.vue?vue&type=script&lang=js"
export * from "./BannerCreateEdit.vue?vue&type=script&lang=js"

import "./BannerCreateEdit.vue?vue&type=style&index=0&id=53a3b586&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-53a3b586"

export default script